// extracted by mini-css-extract-plugin
module.exports = {"editableTitleTextArea":"editableTitleTextArea--28x4p"};